<template>
  <div class="mt-5 max-w-5xl mx-auto">
    <div class="flex flex-col">
      <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
        <div
          v-if="jobs.docs && jobs.docs.length > 0"
          class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
        >
          <table class="min-w-full">
            <thead>
              <tr class="hidden md:table-row">
                <th
                  class="px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                >
                  Order Id
                </th>
                <th
                  class="px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                >
                  Customer name
                </th>
                <th
                  class="px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                >
                  Order created at
                </th>
                <th
                  class="px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                >
                  Message Scheduled at
                </th>
                <th
                  class="px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                >
                  Message Status
                </th>
                <th
                  class="px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                ></th>
                <th
                  class="px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                ></th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr
                class="grid grid-cols-2 grid-flow-row md:table-row"
                v-for="job in jobs.docs"
                :key="job.id"
              >
                <td
                  class="px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
                >
                  {{ job.order.orderNumber }}
                </td>
                <td
                  class="px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
                >
                  {{ job.order.customer.firstName }}
                  {{ job.order.customer.lastName }}
                </td>

                <td
                  class="px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
                >
                  {{ job.order.createdDate | dateFilter }}
                </td>
                <td
                  class="px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
                >
                  <span v-if="job.scheduledTime">
                    {{ job.scheduledTime | dateFilter }}
                  </span>
                </td>
                <td
                  class="px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
                >
                  <span
                    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
                    v-if="job.order.isReviewRequestSent"
                  >
                    Review request sent
                  </span>
                  <span
                    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
                    v-else
                  >
                    Review request not sent
                  </span>
                </td>

                <td
                  class="px-1 md:px-3 py-2 md:py-4 border-b border-gray-200 text-xs leading-5 font-medium text-gray-900 whitespace-pre-wrap"
                >
                  <button
                    v-if="job.scheduledTime != null"
                    @click="sendNow(job)"
                    class="text-blue-800 hover:text-blue-900 text-xs font-medium underline"
                  >
                    Send Now
                  </button>
                </td>
                <td
                  class="px-1 md:px-3 py-2 md:py-4 border-b border-gray-200 text-xs leading-5 font-medium text-gray-900 whitespace-pre-wrap"
                >
                  <button
                    v-if="job.scheduledTime != null"
                    @click="deleteJob(job)"
                    class="text-red-800 hover:text-red-900 text-xs font-medium underline"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <Pagination :page="jobs" @pageChanged="loadPage" />
        </div>
        <div
          class="align-middle inline-block min-w-full  overflow-hidden text-center py-16"
          v-if="!isLoading && jobs.docs && jobs.docs.length === 0"
        >
          <div
            class="Polaris-ShadowBevel"
            style='--pc-shadow-bevel-z-index: 32; --pc-shadow-bevel-content-xs: ""; --pc-shadow-bevel-box-shadow-xs: var(--p-shadow-100); --pc-shadow-bevel-border-radius-xs: var(--p-border-radius-300);'
          >
            <div
              class="Polaris-Box"
              style="--pc-box-background:var(--p-color-bg-surface);--pc-box-min-height:100%;--pc-box-overflow-x:clip;--pc-box-overflow-y:clip;--pc-box-padding-block-start-xs:var(--p-space-400);--pc-box-padding-block-end-xs:var(--p-space-400);--pc-box-padding-inline-start-xs:var(--p-space-400);--pc-box-padding-inline-end-xs:var(--p-space-400)"
            >
              <h2 class="Polaris-Text--root Polaris-Text--bodyMd">
                You don't have any message logs right now. We will be listing
                them here as soon as we sent a message.
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Notification :text="notificationText" :show="showNotification" />
  </div>
</template>

<script>
import { format } from "date-fns";

import Pagination from "../../../components/Common/Pagination";
import Notification from "../../../components/Common/Notification";

export default {
  name: "LooxMessageLogs",
  components: {
    Pagination,
    Notification
  },
  filters: {
    dateFilter(value) {
      return format(new Date(value * 1000), "h:mm a, MMM dd");
    }
  },
  data() {
    return {
      jobs: {},
      isLoading: false,
      notificationText: "",
      showNotification: false
    };
  },
  created() {
    this.loadPage(1);
  },
  methods: {
    loadPage(page) {
      this.$store
        .dispatch("Integrations/getLooxScheduledMessages", { page })
        .then(response => {
          this.jobs = response.jobs;
        });
    },
    sendNow(job) {
      this.$store
        .dispatch("Integrations/sendLooxMessage", { jobId: job.id })
        .then(() => {
          this.loadPage(this.jobs.page);
          this.displayNotification(
            "Message queued, Notification will be sent in few minutes"
          );
        });
    },
    deleteJob(job) {
      this.$store
        .dispatch("Integrations/deleteLooxMessage", { jobId: job.id })
        .then(() => {
          this.loadPage(this.jobs.page);
          this.displayNotification("Message schedule deleted");
        });
    },
    displayNotification(text) {
      this.showNotification = true;
      this.notificationText = text;
      setTimeout(() => {
        this.showNotification = false;
      }, 3000);
    }
  }
};
</script>

<style lang="scss" scoped></style>
